<template>
<div class="policy-file-detail-wrapper">
    <div class="nav-main-con">
        <i class="wl-icon-zhuye1" style="color:#05243D;margin-right:8px;"></i>
        <span>首页</span>
        <span class="sp-nav-line">></span>
        <span v-if="xType == 'jdx'" class="sp-nav-link" @click="toXHome">酒店运营管理</span>
        <span v-if="xType == 'cyx'" class="sp-nav-link" @click="toXHome">餐饮管理运行</span>
        <span class="sp-nav-line">></span>
        <span @click="toXHome" class="sp-nav-link">政策解读</span>
        <span class="sp-nav-line">></span>
        <span>文件详情</span>
    </div>
    <div class="file-detail-main" v-loading="isLoading">
        <!-- <div class="arrow-con left-arrow-con" @click="prevPage">
            <i class="el-icon-arrow-left"></i>
        </div> -->
        <div class="view-pdf-main">
            <pdf v-for="i in numPages" :key="i" :src="url" :page="i"></pdf>
        </div>
        <!-- <div class="arrow-con right-arrow-con" @click="nextPage">
            <i class="el-icon-arrow-right"></i>
        </div> -->
    </div>
</div>
</template>

<script>
import pdf from 'vue-pdf'
export default {
    data() {
        return {
            pdfUrl: '',
            url: '',
            numPages: 1,
            pageNum: 1,
            isLoading: false
        }
    },
    props: {
        xType: {
            type: String,
            default: ''
        },
        fileId: {
            type: String,
            default: ''
        }
    },
    components: {
        pdf
    },
    created() {
        this.getFileDetail();
    },
    methods: {
        getFileDetail() {
            this.isLoading = true;
            this.$http.post('/api/XOrg/homePage/getFileInfo', {
                docId: this.fileId
            }).then(res => {
                if (res.code > 0) {
                    this.getNumPages(res.fileInfo.docUrl);
                }
            });
        },
        toXHome() {
            this.$router.push({
                name: 'xView',
                params: {
                    xType: this.xType
                }
            });
        },
        getNumPages(url) {
            var loadingTask = pdf.createLoadingTask(url);
            loadingTask.promise.then(pdf => {
                this.isLoading = false;
                this.url = loadingTask
                this.numPages = pdf.numPages
            });
        },
        prevPage() {
            if (this.pageNum == 0) {
                return this.$message.warning('已经是第一页了!');
            }
            this.pageNum--;

        },
        nextPage() {
            if (this.pageNum == this.numPages) {
                return this.$message.warning('已经是第一页了!');
            }
            this.pageNum++;
        }
    }
}
</script>

<style lang="scss">
.policy-file-detail-wrapper {
    .nav-main-con {
        margin: 0 auto;
        width: 1200px;
        height: 40px;
        line-height: 40px;
        color: #333333;
        font-size: 14px;

        .sp-nav-line {
            margin: 0 6px;
        }

        .sp-nav-link {
            cursor: pointer;
        }

        .sp-nav-link:hover {
            color: #05243D;
        }
    }

    .file-detail-main {
        position: relative;
        margin: 0 auto 40px;
        width: 1200px;
        border: 1px solid #d3dbe5;
        box-sizing: border-box;
        font-size: 16px;
        line-height: 1.6;
        overflow: auto;

        .view-pdf-main {
            margin: 0 auto;
            padding: 20px 60px 50px 60px;
            height: 800px;
            overflow: auto;
        }

        .arrow-con {
            margin-top: 20px;
            position: absolute;
            top: 50%;
            z-index: 1000;
            width: 40px;
            height: 40px;
            font-size: 20px;
            line-height: 40px;
            text-align: center;
            border-radius: 50%;
            color: #05243D;
            border: 1px solid #05243D;
            cursor: pointer;
        }

        .left-arrow-con {
            left: 20px;
        }

        .right-arrow-con {
            right: 20px;
        }
    }
}

@media only screen and (max-width: 768px) {
    .policy-file-detail-wrapper {
        .nav-main-con {
            padding: 0 10px;
            width: 100%;
            box-sizing: border-box;
            font-size: 13px;
        }

        .file-detail-main {
            padding: 10px 15px;
            width: 100%;
            background: #fff;
            font-size: 13px;

            .file-name-con {
                font-size: 16px;
            }

            .view-pdf-main {
                padding: 0;
                height: auto;
            }
        }
    }
}
</style>
